import classNames from 'classnames';

import IconButton from '../../../components/IconButton';
import Arrow from '../../../components/icons/Arrow';
import { Heading4 } from '../../../components/Text';

import style from './year-select.module.css';

interface YearSelectProps {
  onChangeSelectedIndex: (index: number) => void;
  selectedIndex: number;
  years: number[];
}

const YearSelect = ({
  onChangeSelectedIndex,
  selectedIndex,
  years,
}: YearSelectProps) => {
  const handleClickPrevious = () => {
    if (selectedIndex > 0) {
      onChangeSelectedIndex(selectedIndex - 1);
    }
  };

  const handleClickNext = () => {
    if (selectedIndex < years.length - 1) {
      onChangeSelectedIndex(selectedIndex + 1);
    }
  };

  const handleClickYear = (index: number) => () => {
    onChangeSelectedIndex(index);
  };

  const isPreviousDisabled = selectedIndex === 0;
  const isNextDisabled = selectedIndex === years.length - 1;

  return (
    <div className={style.yearSelect}>
      <IconButton
        aria-label="Previous year"
        disabled={isPreviousDisabled}
        onClick={handleClickPrevious}
      >
        <Arrow
          direction="left"
          disabled={isPreviousDisabled}
          iconColor="black"
        />
      </IconButton>

      <div className={style.yearContainer}>
        {years.map((year, index) => {
          const isActive = index === selectedIndex;

          return (
            <Heading4
              className={classNames(
                style.year,
                {
                  [style.active]: isActive,
                },
              )}
              fontColor={isActive ? 'turquoise' : undefined}
              fontSizeOverride={30}
              key={year}
            >
              <button onClick={handleClickYear(index)}>
                {year}
              </button>
            </Heading4>
          );
        })}
      </div>

      <IconButton
        aria-label="Next year"
        disabled={isNextDisabled}
        onClick={handleClickNext}
      >
        <Arrow
          disabled={isNextDisabled}
          iconColor="black"
        />
      </IconButton>
    </div>
  );
};

export default YearSelect;
